import type { SxProps } from "@mui/material"

import { GRAY_COLOR, PRIMARY } from "@constants/colors"

const optionContainer: SxProps = {
  display: "flex",
  cursor: "pointer",
  color: GRAY_COLOR,
  height: "1.1rem"
}

const optionContainerActive: SxProps = {
  display: "flex",
  cursor: "pointer",
  color: PRIMARY,
  height: "1.1rem"
}
export default {
  optionContainer,
  optionContainerActive
}
